module.exports = __webpack_public_path__ + "static/12-eb9e302151ac1d232dabd8d7df351523.jpg";